/* ==================================================================
   The Light Heritage — photos des cartes produit chargées à la demande
   [19/10/2026] Accompagne snippets/card-gallery.liquid (tlh_defer_card_photos).
   Chargé par layout/theme.liquid, en defer.

   Constat mesuré (page Pendant Lights, 40 cartes) : chaque carte embarque
   un petit carrousel de 5 photos et le navigateur en téléchargeait 4 par
   carte pendant le défilement (147 photos, 8,8 Mo), alors qu'une seule
   est visible. C'est ce qui faisait saccader le défilement de la page
   collection.

   Désormais, les photos 2 à 5 de chaque carte arrivent sans adresse
   (data-tlh-src / data-tlh-srcset). Ce script la leur rend :
     - photo 2 seule : quand la carte reste visible à l'écran au moins
       0,3 s (le client s'est arrêté dessus), pour que le survol et le
       premier glissement restent instantanés ;
     - photos 2 à 5 : au survol de la carte à la souris, au focus clavier,
       ou dès que le carrousel de la carte commence à glisser (mobile).
   Les cartes qui ne font que passer à l'écran pendant le défilement ne
   chargent donc que leur 1re photo.

   Pare-feu : si ce script ne tourne pas, rien n'est cassé, la 1re photo
   de chaque carte reste affichée. Sans IntersectionObserver (très vieux
   navigateur), toutes les photos sont rendues tout de suite, comme avant.
   ================================================================== */
(function () {
  'use strict';

  var DEFERRED = 'img[data-tlh-src], img[data-tlh-srcset]';
  var STAY_MS = 300;
  var io = null;

  function restore(img) {
    var srcset = img.getAttribute('data-tlh-srcset');
    var src = img.getAttribute('data-tlh-src');
    if (srcset) {
      img.setAttribute('srcset', srcset);
      img.removeAttribute('data-tlh-srcset');
    }
    if (src) {
      img.setAttribute('src', src);
      img.removeAttribute('data-tlh-src');
    }
  }

  /* toutes les photos de la carte */
  function restoreAll(gallery) {
    if (!gallery || gallery.getAttribute('data-tlh-photos') === 'all') return;
    gallery.setAttribute('data-tlh-photos', 'all');
    if (gallery.__tlhTimer) {
      clearTimeout(gallery.__tlhTimer);
      gallery.__tlhTimer = null;
    }
    if (io) io.unobserve(gallery);
    gallery.querySelectorAll(DEFERRED).forEach(restore);
  }

  /* la photo 2 seulement (la première encore sans adresse, dans l'ordre du carrousel) */
  function restoreNext(gallery) {
    if (!gallery || gallery.hasAttribute('data-tlh-photos')) return;
    gallery.setAttribute('data-tlh-photos', 'next');
    var img = gallery.querySelector(DEFERRED);
    if (img) restore(img);
  }

  function galleryOf(node) {
    return node && node.closest ? node.closest('.card-gallery') : null;
  }

  /* Ordinateur : survol à la souris (pointerover remonte jusqu'au document, pointerenter non).
     Le doigt sur mobile déclenche aussi pointerover : on l'ignore, sinon chaque carte touchée
     en faisant défiler la page chargerait ses 5 photos. */
  document.addEventListener(
    'pointerover',
    function (e) {
      if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== 'pen') return;
      restoreAll(galleryOf(e.target));
    },
    { passive: true }
  );

  /* Clavier */
  document.addEventListener('focusin', function (e) {
    restoreAll(galleryOf(e.target));
  });

  /* Mobile : le carrousel de la carte commence à glisser.
     L'événement scroll ne remonte pas : on l'écoute en phase de capture. */
  document.addEventListener(
    'scroll',
    function (e) {
      var t = e.target;
      if (t && t.nodeType === 1 && t.tagName === 'SLIDESHOW-SLIDES') restoreAll(galleryOf(t));
    },
    { passive: true, capture: true }
  );

  /* Photo 2 : carte visible (au moins 60 %) pendant 0,3 s */
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var g = entry.target;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            if (!g.__tlhTimer) {
              g.__tlhTimer = setTimeout(function () {
                g.__tlhTimer = null;
                if (io) io.unobserve(g);
                restoreNext(g);
              }, STAY_MS);
            }
          } else if (g.__tlhTimer) {
            clearTimeout(g.__tlhTimer);
            g.__tlhTimer = null;
          }
        });
      },
      { threshold: [0, 0.6] }
    );
  }

  function track(gallery) {
    if (gallery.__tlhTracked || !gallery.querySelector(DEFERRED)) return;
    gallery.__tlhTracked = true;
    if (io) io.observe(gallery);
    else restoreAll(gallery);
  }

  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.classList && root.classList.contains('card-gallery')) track(root);
    root.querySelectorAll('.card-gallery').forEach(track);
  }

  scan(document.documentElement);

  /* Cartes ajoutées après coup : filtres, pagination, recommandations, éditeur de thème. */
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(scan);
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
